import type AddressFormErrorHeaders from "@interfaces/address/AddressFormErrorHeaders";
import { CommonCMS, commonReplacements, Checkout, Address } from "@lib/constants/contentful";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { useFormFieldsMicrocopy } from "./FormFields.microcopy";
import { useApplyLocalizedErrorMessages } from "@lib/validators/yupConfig";
import { ADDRESS_LINE_1_MAX_LENGTH } from "@lib/validators/checkout/schemas/specific.schema";

export const useDeliveryStepFormMicrocopy = () => {
    const { get: getMicrocopy } = useMicrocopy();
    const { headers: formFieldLabels } = useFormFieldsMicrocopy();

    // Configure Yup with localized error messages
    useApplyLocalizedErrorMessages();

    const headerErrors: AddressFormErrorHeaders = {
        //TODO: Remove firstName and lastName fields after the full merge of my-addresses feature
        firstName: getMicrocopy(CommonCMS.page, Address.error.firstNameOnlyAlphabetic),
        lastName: getMicrocopy(CommonCMS.page, Address.error.lastNameOnlyAlphabetic),
        address: getMicrocopy(CommonCMS.page, Address.error.addressField),
        cityNumbers: getMicrocopy(CommonCMS.page, Address.error.cityContainsNumbers),
        requiredField: getMicrocopy(CommonCMS.page, CommonCMS.error.requiredFieldError),
        firstNameLabel: formFieldLabels.firstName,
        lastNameLabel: formFieldLabels.lastName,
        companyLabel: formFieldLabels.company,
        streetNameLabel: formFieldLabels.streetName,
        cityLabel: formFieldLabels.city,
        districtLabel: formFieldLabels.district,
        postalCodeLabel: formFieldLabels.postalCode,
        regionLabel: formFieldLabels.region,
        vatNumberLabel: formFieldLabels.vatNumber,
        customerNumberLabel: formFieldLabels.customerNumber,
        salutationLabel: formFieldLabels.salutation,
        phoneticFirstNameLabel: formFieldLabels.phoneticFirstName,
        phoneticLastNameLabel: formFieldLabels.phoneticLastName,
        addressLine2Label: formFieldLabels.addressLine2,
        landmarkLabel: formFieldLabels.landmark,
        countryLabel: formFieldLabels.country,

        zipCodeValid: getMicrocopy(CommonCMS.page, Address.error.zipCode),
        maxNameCharacters: getMicrocopy(CommonCMS.shared, CommonCMS.error.maxCharacters, {
            replacements: commonReplacements.maxNameCharacters,
        }),
        maxCompanyCharacters: getMicrocopy(CommonCMS.shared, CommonCMS.error.maxCharacters, {
            replacements: commonReplacements.maxCompanyCharacters,
        }),
        maxAddressCharacters: getMicrocopy(CommonCMS.shared, CommonCMS.error.maxCharacters, {
            replacements: commonReplacements.maxAddressCharacters,
        }),
        streetNameMaxLength: getMicrocopy(CommonCMS.page, Address.error.streetNameMaxLength, {
            replacements: { maxCharacters: ADDRESS_LINE_1_MAX_LENGTH },
        }),
        poBox: getMicrocopy(CommonCMS.page, Address.error.poBox),
        phoneticInvalid: getMicrocopy(CommonCMS.page, Address.error.phoneticInvalid),
        vatNumber: getMicrocopy(CommonCMS.page, Address.error.vatNumber),
        customerNumber: getMicrocopy(CommonCMS.page, Address.error.customerNumber),
    };

    const headerLabels = {
        shippingAddress: getMicrocopy(CommonCMS.page, Checkout.step2.shippingAddress),
        addressesMatch: getMicrocopy(CommonCMS.page, Checkout.step2.addressesMatch),
        continueToPayment: getMicrocopy(CommonCMS.page, Checkout.step2.button.title),
    };

    return { headerErrors, headerLabels };
};
